<!--RIS-->
<!--v1.0-->
<!--历史报告-->
<!--陈宇-->
<!--2018.08.15-->
<template>
  <div class="history-continer">
    <el-row id="history-wrapper" class="history-wrapper">
      <el-row class="history-subheader">
        历史报告
      </el-row>
      <el-row class="main">
        <el-col :span="24" class="history-main">
          <!--基本资料开始-->
          <div class="content-wrapper">
            <el-row style="padding:10px 0px;">
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right" :span='12'>
                    患者姓名：
                  </el-col>
                  <el-col style="text-align:left;" :span='12'>
                    {{patientInfo.patientName}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right;" :span='12'>
                    性别：
                  </el-col>
                  <el-col style="text-align:left;" :span='12'>
                    {{patientInfo.sex}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right;" :span='12'>
                    年龄：
                  </el-col>
                  <el-col style="text-align:left;word-break: break-all;" :span='12'>
                    {{patientInfo.age}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right;" :span='12'>
                    影像号：
                  </el-col>
                  <el-col style="text-align:left;word-break: break-all;" :span='12'>
                    {{patientInfo.patientNo}}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
           <!--基本资料结束-->
          <div class="history-cont">
            <el-table v-if='patientReportList.length > 0' stripe :data='patientReportList' size='mini'  style='width: 100%' >
              <el-table-column prop='modality' label='设备类型' width='100px'>
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                      {{ scope.row.modality }}    
                    <div slot="reference" class="name-wrapper">
                      <span style='background:#FF8C8C;'>{{ scope.row.modality }}</span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop='bodyParts' label='检查部位' width='100px'>
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                      {{ scope.row.bodyParts }}    
                    <div slot="reference" class="name-wrapper">
                      <span style='background:#49C1E4;'>{{ scope.row.bodyParts }}</span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop='checkingItems' label='检查项目' width='120px'>
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                      {{ scope.row.checkingItems }}    
                    <div slot="reference" class="name-wrapper">
                      <span>{{ scope.row.checkingItems }}</span>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop='createrName' label='报告医生' width='100px' > </el-table-column>
              <el-table-column prop='firstApproverName' label='审核医生' width='100px' > </el-table-column>
              <el-table-column prop='submitTime' label='完成时间' width='120px'> </el-table-column>
              <el-table-column prop='wys' label='检查所见' >
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.wys" placement="top" effect="light">
                    <span style="width: 100%;text-overflow: ellipsis;display: inline-block;overflow: hidden;white-space: nowrap;">{{scope.row.wys}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop='wyg' label='诊断所得' >
                <template slot-scope="scope">
                  <el-tooltip :content="scope.row.wyg" placement="top" effect="light">
                    <span style="width: 100%;text-overflow: ellipsis;display: inline-block;overflow: hidden;white-space: nowrap;">{{scope.row.wyg}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop label='影像' width='100px' > 
                <template slot-scope='scope'>
                  <el-tooltip class="item" effect="dark" content="查看影像" placement="top">
                    <el-button
                      style="background:#5AB1EF;color:#fff;border:none;float:left;margin-right:10px;"
                      type
                      size="mini"
                      circle
                      @click="pacsImg(scope.row.webPacsUrl)"
                    >
                      <svg-icon icon-class="preview_1"></svg-icon>
                    </el-button>
                </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div v-else style="width:100%;height: calc(100vh - 160px);text-align:center;background:#f8f8f8;">
              <img src="../../assets/empty_01.png" alt="" style="height: calc(100vh - 353px);width: auto;" />
            </div>
          </div>
        </el-col>
      </el-row>
    </el-row>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'history',
  data() {
    return {
      reportId: ''
    }
  },
  created: function() {
    this.reportId = this.$route.query.reportId
    this.init()
  },
  computed: {
    ...mapGetters([
      'patientReportList',
      'patientInfo'
    ])
  },
  methods: {
    init: function() {
      this.$store
        .dispatch('gethistoryReport', this.reportId)
        .then(() => {
        })
        .catch(() => {
        })
    },
    pacsImg: function(url) {
      window.open(
        url,
        'pacsImg',
        'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes'
      )
    }
  }
}
  </script>

  <style  rel="stylesheet/scss" lang="scss" scoped>
  .history-continer{
    overflow-y: auto;
    height:100%;
    .history-wrapper{
      width:95%;
      margin: 0 auto;
      //padding: 30px 0;
    }
    .history-subheader{
      color: #3A4A64;
      height: 60px;
      line-height: 60px;
      border-bottom:2px solid #ddd;
      font-size: 18px;
    }
    .main{
      margin-top:20px;
      .el-menu{
        border:none;
        height: calc(100vh - 80px);
        background-color: #f8f8f8;
        .el-menu-item{
          height: 65px;
          line-height: 65px;
        }
      }
      .history-cont{
        margin-top:20px; 
      }
      .history-main{
        .content-wrapper{
          background: #f8f8f8;  
          line-height: 20px;
        }
      }
    }
    .name-wrapper{
      span{
        background: #FF9D60;
        color:#fff;
        padding: 0px 5px;
        border-radius: 3px;
        width: 100%;
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  </style>
